import apiClient from './api';
import type { ServerCartResponse, AddToCartPayload, UpdateQuantityPayload, CartMergePayload, CartRevalidationResult } from '../types/cart.types';

export const fetchServerCart = (): Promise<ServerCartResponse> =>
  apiClient.get<ServerCartResponse>('/cart/').then(r => r.data);

export const addToServerCart = (payload: AddToCartPayload): Promise<ServerCartResponse> =>
  apiClient.post<ServerCartResponse>('/cart/items/', payload).then(r => r.data);

export const updateServerCartItem = (itemId: string, payload: UpdateQuantityPayload): Promise<ServerCartResponse> =>
  apiClient.patch<ServerCartResponse>(`/cart/items/${itemId}/`, { quantity: payload.quantity }).then(r => r.data);

export const removeServerCartItem = (itemId: string): Promise<ServerCartResponse> =>
  apiClient.delete<ServerCartResponse>(`/cart/items/${itemId}/`).then(r => r.data);

export const clearServerCart = (): Promise<void> =>
  apiClient.delete('/cart/').then(() => undefined);

export const mergeGuestCart = (payload: CartMergePayload): Promise<ServerCartResponse> =>
  apiClient.post<ServerCartResponse>('/cart/merge/', payload).then(r => r.data);

export const revalidateCart = (): Promise<CartRevalidationResult> =>
  apiClient.post<CartRevalidationResult>('/cart/revalidate/').then(r => r.data);